import type { FC } from 'react';

import { AttentionIcon } from '../../icons/Attention';

interface ErrorValidationMessageProps {
	message: string;
}

const ErrorValidationMessage: FC<ErrorValidationMessageProps> = ({
	message,
}) => {
	return (
		<>
			<AttentionIcon width={15} height={15} />
			<span>{message}</span>
		</>
	);
};

export default ErrorValidationMessage;
